var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('v-row',[_c('v-col',[_c('h1',[_vm._v("Api Status")])])],1),_c('v-row',[_c('v-col',[_c('ApiStatuses')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }